import { TESTING_PLACE_ISUSE } from '../constants/testing_place';
import { TESTING_PLACE_SCHEDULE_STATUS } from '../constants/testing_place_schedule';
import { TESTING_TEACHER_STATUS } from '../constants/testing_teacher';

async function restapi(method, host, page, data, headers = {}, isEcho = false) {
  let url = `${host}${page}`;
  if (isEcho) console.log("url: ", url);

  const token = localStorage.getItem('token');
  
  if (headers === undefined) headers = {};
  if (headers['Content-Type'] === undefined) headers['Content-Type'] = 'application/json';
  if (headers['Authorization'] === undefined && token) headers.Authorization = `Bearer ${token}`;

  const options = {
    method: method,
    headers: headers,
  };

  if (isEcho) console.log("options: ", options);

  if (method.toUpperCase() === 'GET') {
    if (data) url += `?${new URLSearchParams(data).toString()}`;
  } else {
    options.body = JSON.stringify(data);
  }

  const response = await fetch(url, options);

  if(isEcho) console.log("response: ", response);

  if (!response.ok) {
    console.error(response);
    throw new Error(`서버 응답 없음 : ${response.status}`);
  }

  return await response.json();
}

async function isValidBankAccount(bank, account, name, isEcho = false) {
  const method = 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/nicepay/isValidBankAccount';
  const data = {
    bank: bank,
    account: account,
    name: name,
  };

  const response = await restapi(method, host, page, data);
  if (isEcho) console.log("response: ", response);

  return response.result;
}

async function search_zipcode(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/zipcode/search';

  const response = await restapi(method, host, page, json, {}, true);
  return response;
}

async function person_update(person_id, data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/${person_id}`;
  const response = await restapi(method, host, page, data);
  if (!response.result) throw new Error(`개인정보 변경 실패! 원인 - ${response.message}`);
  return response.data;
}

async function get_person_signature(person_id) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/signature/${person_id}`;
  const response = await restapi(method, host, page, {}, {}, true);
  if (!response.result) throw new Error(`서명 이미지 조회 실패! 원인 - ${response.message}`);
  return response.data;
} 

async function person_signature_update(person_id, data) {
  const method = 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/signature/${person_id}`;
  const response = await restapi(method, host, page, data);
  if (!response.result) throw new Error(`서명 이미지 변경 실패! 원인 - ${response.message}`);
  return response.data;
}

async function person_nameImage_delete(person_id) {
  const method = 'DELETE';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/name_image/${person_id}`;
  const response = await restapi(method, host, page, {});
  if (!response.result) throw new Error(`서명 이미지 삭제 실패! 원인 - ${response.message}`);
  return response.data;
}

async function person_signatureImage_delete(person_id) {
  const method = 'DELETE';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/person/signature_image/${person_id}`;
  const response = await restapi(method, host, page, {});
  if (!response.result) throw new Error(`서명 이미지 삭제 실패! 원인 - ${response.message}`);
  return response.data;
}

async function user_update(user_id, data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/user/${user_id}`;
  const response = await restapi(method, host, page, data);
  if (!response.result) throw new Error(`개인정보 변경 실패! 원인 - ${response.message}`);
  return response.data;
}

async function get_user(user_id) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/user/${user_id}`;

  const response = await restapi(method, host, page);
  return response;
}

async function get_testing_teacher_documents(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_teacher/documents';

  const response = await restapi(method, host, page, json);
  return response;
}

async function testing_teacher_document_update(pkValue, data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/testing_teacher_document/${pkValue}`;

  const response = await restapi(method, host, page, data, {}, true);
  if (!response.result) throw new Error(`테스트 교사 문서 등록 실패! 원인 - ${response.message}`);
  return response.data;
}

async function get_testing_place_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_place/list';

  if (!json.page) json.page = 1;
  if (!json.rowsPerPage) json.rowsPerPage = 20;
  if (!json.sort) json.sort = 'a_testing_place_id';
  if (!json.desc) json.desc = 'desc';
  if (!json.keyword) json.keyword = '';

  console.log("get_testing_place_list : ", json);

  const response = await restapi(method, host, page, json);
  return response;
}

async function get_testing_place(testing_place_id) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/testing_place/${testing_place_id}`;
  console.log(`page : ${page}`)
  const response = await restapi(method, host, page);
  return response;
}

async function get_place_testing_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/place/testing';

  if (!json.page) json.page = 1;
  if (!json.rowsPerPage) json.rowsPerPage = 1000;
  if (!json.sort) json.sort = 'a_name';
  if (!json.desc) json.desc = 'asc';
  if (!json.keyword) json.keyword = '';

  console.log("get_place_testing_list : ", json);

  const response = await restapi(method, host, page, json);
  return response;
}

async function create_testing_place(data) {
  const method = 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_place';

  const response = await restapi(method, host, page, data, {}, true);
  return response;
}

async function update_testing_place(data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/testing_place/${data.testing_place_id}`;

  const response = await restapi(method, host, page, data);
  return response;
}

async function upsert_testing_place(data) {
  return data.testing_place_id ? await update_testing_place(data) : await create_testing_place(data);
}

async function delete_testing_place(testing_place_id) {
  return await update_testing_place({ testing_place_id, status: TESTING_PLACE_ISUSE.DELETE });
}

async function get_place_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/place/list';

  if (!json.page) json.page = 1;
  if (!json.rowsPerPage) json.rowsPerPage = 20;
  if (!json.sort) json.sort = 'a_name';
  if (!json.desc) json.desc = 'desc';
  if (!json.keyword) json.keyword = '';

  console.log("get_place_list : ", json);

  const response = await restapi(method, host, page, json, {}, true);
  return response;
}

async function upsert_place(data) {
  const method = data.place_id ? 'PUT' : 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = data.place_id ? `/place/${data.place_id}` : '/place';

  const response = await restapi(method, host, page, data);
  return response;
}

async function get_testing_type() {
  console.log('get_testing_type call');
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/code/group/testing_type';

  const response = await restapi(method, host, page);
  return response;
}

async function get_testing_list(json) {
  console.log('get_testing_list call : ', json);
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing/list';

  const response = await restapi(method, host, page, json);
  return response;
}

async function get_testing_hq(person_id) {
  // console.log('get_testing_hq call : ', person_id);
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_hq/search';

  const json = {
    person_id
  };

  const response = await restapi(method, host, page, json);
  return response;
}

async function get_testing_schedule_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_schedule/list';

  const response = await restapi(method, host, page, json);
  return response;
}

async function get_testing_place_schedule_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_place_schedule/list';

  const response = await restapi(method, host, page, json, {}, true);
  return response;
}

async function create_testing_place_schedule(data) {
  const method = 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_place_schedule';

  const response = await restapi(method, host, page, data);
  return response;
}

async function update_testing_place_schedule(data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/testing_place_schedule/${data.testing_place_schedule_id}`;

  const response = await restapi(method, host, page, data);
  return response;
}

async function upsert_testing_place_schedule(data) {
  const method = data.testing_place_schedule_id ? 'PUT' : 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = data.testing_place_schedule_id ? `/testing_place_schedule/${data.testing_place_schedule_id}` : '/testing_place_schedule';

  const response = await restapi(method, host, page, data);
  return response;
}

async function delete_testing_place_schedule(testing_place_schedule_id) {
  return await update_testing_place_schedule({ testing_place_schedule_id, status: TESTING_PLACE_SCHEDULE_STATUS.field.delete });
}

async function get_testing_teacher_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_teacher/list';

  const response = await restapi(method, host, page, json);
  return response;
}

async function create_testing_teacher(data) {
  const method = 'POST';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_teacher';

  const response = await restapi(method, host, page, data);
  return response;
}

async function update_testing_teacher(data) {
  const method = 'PUT';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/testing_teacher/${data.testing_teacher_id}`;

  const response = await restapi(method, host, page, data);
  return response;
}

async function upsert_testing_teacher(data) {
  return data.testing_teacher_id ? await update_testing_teacher(data) : await create_testing_teacher(data);
}

async function delete_testing_teacher(testing_teacher_id) {
  const json = { testing_teacher_id, status: TESTING_TEACHER_STATUS.field.delete };
  console.log('delete_testing_teacher called with:', json);
  return await update_testing_teacher(json);
}

async function get_testing_accept_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_accept/list';

  const response = await restapi(method, host, page, json);
  return response;
}

// 고사장별 접수인원 카운트 (GROUP BY 집계 — getMap 미사용, 대량에도 빠름)
// 응답: { total, lists: [{ testing_place_id, status, cnt }] }
async function get_testing_accept_count(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_accept/count';

  const response = await restapi(method, host, page, json);
  return response;
}

// 고사장별 고사실수·접수인원 총계 (응시자명단/좌석배치도 목록 화면용)
// 응답: { total, lists: [{ testing_place_id, rooms, accept_users }] }
async function get_testing_accept_summary(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_accept/summary';

  const response = await restapi(method, host, page, json);
  return response;
}

async function get_testing_hq_doc_list(json) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = '/testing_hq_doc/list';

  const response = await restapi(method, host, page, json, {}, true);
  return response;
}

async function download_testing_hq_doc(cloud_file_id) {
  const method = 'GET';
  const host = process.env.REACT_APP_RESTAPI_URL;
  const page = `/cloud_file/download/${cloud_file_id}`;

  const response = await fetch(`${host}${page}`, {
    method: method,
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
  });

  if (!response.ok) {
    throw new Error(`서버 응답 없음 : ${response.status}`);
  }

  return response;
}

// ES6 export 방식으로 변경
export {
  restapi,
  isValidBankAccount,
  search_zipcode,
  person_update,
  get_person_signature,
  person_signature_update,
  person_nameImage_delete,
  person_signatureImage_delete,
  user_update,
  get_user,
  get_testing_teacher_documents,
  testing_teacher_document_update,
  get_testing_place_list,
  get_testing_place,
  create_testing_place,
  update_testing_place,
  upsert_testing_place,
  delete_testing_place,
  get_place_testing_list,
  get_testing_schedule_list,
  get_testing_place_schedule_list,
  create_testing_place_schedule,
  update_testing_place_schedule,
  delete_testing_place_schedule,
  upsert_testing_place_schedule,
  get_testing_teacher_list,
  create_testing_teacher,
  update_testing_teacher,
  delete_testing_teacher,
  upsert_testing_teacher,
  get_testing_hq_doc_list,
  get_testing_type,
  get_testing_list,
  get_place_list,
  upsert_place,
  get_testing_hq,
  get_testing_accept_list,
  get_testing_accept_count,
  get_testing_accept_summary,
  download_testing_hq_doc,
};
